import * as React from "react";

import { JoinDrawer } from "../../Common";

import {
  ReactCheckout2022Route,
  useReactCheckout2022Router,
  useReactMyBagInitialState,
} from "../providers";

import { DrawerFragment_OutOfStock } from "../drawer-fragment-out-of-stock";
import { DrawerFragment_Delivery } from "../drawer-fragment-delivery";
import { DrawerFragment_GiftcardHelp } from "../drawer-fragment-giftcard-help";

export const DrawerCheckout2022: React.FunctionComponent = (props) => {
  const { currentRoute } = useReactCheckout2022Router();
  return (
    <React.Fragment>
      <JoinDrawer
        useInitialState={useReactMyBagInitialState}
        allowJoining={currentRoute === ReactCheckout2022Route.mybag}
      />

      <DrawerFragment_OutOfStock />

      <DrawerFragment_Delivery />

      <DrawerFragment_GiftcardHelp />
    </React.Fragment>
  );
};
